// extracted by mini-css-extract-plugin
export default {"icons":"PropertiesCard_icons__QjiHX","greyText":"PropertiesCard_greyText__XfWZz"};